import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router'

import { MiniappRootRoute } from './MiniappRootRoute'
import { NotFoundComponent } from '@/features/errors/NotFoundComponent'
import { Savings } from '@/pages/Savings'

const rootRoute = createRootRoute({
  notFoundComponent: NotFoundComponent,
  component: MiniappRootRoute,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Savings,
})

const savingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/savings/$domain/$savingsToken',
  component: Savings,
})

const routeTree = rootRoute.addChildren([indexRoute, savingsRoute])

export const miniappRouter = createRouter({
  routeTree,
})
